var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChrome = function SvgChrome(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_3782_13310)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip1_3782_13310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.636 9A3.367 3.367 0 019 5.637 3.367 3.367 0 0112.363 9 3.367 3.367 0 019 12.364 3.367 3.367 0 015.636 9zm11.109-4.44a.147.147 0 01-.128.075H9.38a4.382 4.382 0 00-4.625 3.27.148.148 0 01-.27.037L1.951 3.554a.147.147 0 01.012-.166A8.96 8.96 0 019 0a8.993 8.993 0 017.744 4.412.148.148 0 010 .149zm-6.415 8.715a.148.148 0 01.011.164l-2.534 4.39a.148.148 0 01-.15.072A8.998 8.998 0 010 9c0-1.547.4-3.073 1.155-4.413a.148.148 0 01.128-.075c.052 0 .102.028.128.073l3.614 6.26A4.405 4.405 0 009 13.383c.398 0 .793-.054 1.174-.16a.147.147 0 01.156.052zm6.913-7.655c.06 0 .115.037.137.093A8.954 8.954 0 0118 9a8.944 8.944 0 01-2.603 6.33A8.945 8.945 0 019.102 18H9.1a.148.148 0 01-.127-.222l3.62-6.27A4.351 4.351 0 0013.383 9a4.349 4.349 0 00-1.317-3.128.147.147 0 01.103-.253h5.074z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_3782_13310"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip1_3782_13310"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgChrome;